import {getAnalytics, logEvent} from "firebase/analytics";

export const logAnalytics = (name) => {
    const analytics = getAnalytics();
    logEvent(analytics, name);
}